import { BrowserModule } from "@angular/platform-browser";
import { NgModule, APP_INITIALIZER, ErrorHandler } from "@angular/core";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AlertConfirmPopupModule } from "./common/alert-confirm-popup";
import {OverlayContainer} from '@angular/cdk/overlay';

// components
import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app-routing.module";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { AccountManagementResolver } from "./services/account-management.resolver";
import { APP_BASE_HREF, CurrencyPipe, DatePipe, TitleCasePipe } from "@angular/common";
import { EnvironmentDetailsService } from "./services/environment-details.service";
import { ContentProvider } from "./common/core/content.provider";
import { LoaderService } from "./services/loader.service";
import { AuthHttpInterceptor } from "./services/auth-http-interceptor";
import { AuthHttpService } from "./services/http-wrapper.service";
import { HttpCacheInterceptor } from "./services/http-cache.interceptor";
import { HttpCacheService } from "./services/http-cache.service";
export function contentProviderFactory(provider: ContentProvider) {
  return () => provider.load();
}

import { GlobalErrorHandler } from "./services/errorHandler";
// tslint:disable-next-line:ordered-imports
// tslint:disable-next-line:ordered-imports
import { environment } from "../environments/environment";
import { FileUploadDirective } from "./common/directives/file-upload.directive";
import { OktaCallbackComponent } from "./okta-callback/okta-callback.component";
import { AccountManagementLoginGuard } from "./services/account-mgmt-login.resolver";
import { RestrictPageComponent } from "./common/restrict-page/restrict-page.component";
import { OktaAuthorizationService } from "./services/okta-auth-service";
import { PnpframeworkModule } from "src/pnpframework/public-api";
import { RootComponent } from "./root-component/root.component";
import { EmptyRouteComponent } from "./empty-route/empty-route.component";
import { ApiInterceptor } from "src/pnpframework/lib/http-interceptors/api-interceptor";
import {AppConfig} from './app.config';
import { SharedModule } from "./shared/shared.module";
import { SplunkUtilityService } from "./services/splunk-utility.service";
import { ChangeServiceModule } from "./change-service/change-service.module";
import { IotService } from "./services/iot.service";
import { HttpLoggingInterceptor } from "./services/http-logging.interceptor";

@NgModule({
    declarations: [
        AppComponent,
        FileUploadDirective,
        OktaCallbackComponent,
        RestrictPageComponent,
        RootComponent,
        EmptyRouteComponent,
        // add components in feature module only
    ],
    imports: [
        ChangeServiceModule,
        SharedModule,
        AppRoutingModule,
        BrowserModule, BrowserAnimationsModule,
        AlertConfirmPopupModule,
        PnpframeworkModule.forRoot(environment.PNP_CONFIG)
    ],
    providers: [
        AuthHttpService,
        HttpCacheService,
        AccountManagementResolver,
        HttpCacheService,
        ContentProvider,
        SplunkUtilityService,
        CurrencyPipe,
        EnvironmentDetailsService,
        LoaderService,
        DatePipe,
        TitleCasePipe,
        AccountManagementLoginGuard,
        OktaAuthorizationService,
        IotService,
        {
            provide: APP_INITIALIZER,
            useFactory: contentProviderFactory,
            deps: [ContentProvider],
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthHttpInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ApiInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpCacheInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpLoggingInterceptor,
            multi: true,
        },
        {
            provide: ErrorHandler,
            useClass: GlobalErrorHandler,
        },
        { provide: APP_BASE_HREF, useValue: '/' },
        { provide: OverlayContainer, useClass: AppConfig },
    ],
    bootstrap: [AppComponent]
})
export class AppModule {}
